import { useNavigate, useOutletContext } from "react-router";
import QuizNavigation from "../components/QuizNavigation/QuizNavigation";
import QuestionIntroduction from "../components/QuestionIntroduction/QuestionIntroduction";
import Answer from "../components/Input/Answer/Answer";
import PageTitle from "../components/PageTitle/PageTitle";

function Question() {
    const {
        questions,
        answers,
        setAnswers,
        questionsValidated,
        setQuestionsValidated,
        questionIndex
    } = useOutletContext();

    // Hook pour la navigation
    let navigate = useNavigate();

    // Vérifier que les questions sont bien chargées
    // Sinon on affiche un message pour temporiser
    if (questions.length === 0) return <p>Chargement...</p>;

    // Fonction pour gérer les réponses
    const handleAnswer = (answerType) => {
        // Ajoute la réponse au tableau
        if (answers[`q${questionIndex}`] === undefined) {
            setAnswers((prev) => {
                return { ...prev, [`q${questionIndex}`]: answerType };
            });
        } else {
            setAnswers((prev) => {
                prev[`q${questionIndex}`] = answerType;
                return { ...prev };
            });
        }
    };

    // Fonction pour charger la question suivante ou afficher le résultat
    const handleNext = () => {
        // Vérifie si on est à la dernière question
        // Si non, on charge la question suivante
        // Si oui, on affiche le résultat
        if (questionIndex + 1 < questions.length) {
            navigate(`/quiz/${questionIndex + 1}`);
        } else {
            navigate("/quiz/result");
        }
    };

    // Si on est n'est pas à la première question et que la question précédente est dans la
    // liste des réponses alors on ajoute la question dans l'état validé
    if (questionIndex > 0 && answers[`q${questionIndex - 1}`] !== undefined && questionsValidated < questionIndex) {
        setQuestionsValidated(questionsValidated + 1);
    }

    // On définit les classes pour le container principal
    let containerClass = `quiz__container quiz__container--${questionIndex + 1}`;

    return (
        <>
            <PageTitle title={`Si j'étais une radio, question ${questionIndex + 1} sur ${questions.length}`} />
            {questions.length > 0 && (
                <main role="main" className={containerClass}>
                    <QuestionIntroduction qid={questionIndex} length={questions.length} />
                    <div className="question__container grid--container">
                        <h2 className="question-intitule" id={"intitule--" + (questionIndex + 1)}>
                            {questions[questionIndex].question}
                        </h2>
                        <div role="list" className="answers-list input-list" aria-labelledby={"intitule--" + (questionIndex + 1)}>
                            {questions[questionIndex].options.map((option) => (
                                <Answer
                                    key={String(questionIndex) + String(option.id)}
                                    option={option}
                                    questionIndex={questionIndex}
                                    answers={answers}
                                    handleAnswer={handleAnswer} />
                            ))}
                        </div>
                        <QuizNavigation
                            length={questions.length}
                            currentQuestion={questionIndex}
                            answers={answers}
                            handleNext={handleNext}
                        />
                    </div>
                </main>
            )}
        </>
    );
}

export default Question;
